<template>
  <figure>
    <h3 class="subtitle is-5">Groups</h3>
    <ul>
      <li v-for="g in agg" :key="g.key">
        <b-checkbox v-model="selectedGroups" :native-value="g.key">
          <b-taglist class="has-addons">
            <b-tag type="is-info is-light" size="is-medium">
              <font-awesome-icon icon="tag" class="mr-2"/>
              {{ g.key }}
            </b-tag>
            <b-tag type="is-info is-light" size="is-medium">{{ g.count.toLocaleString() }}</b-tag>
          </b-taglist>
        </b-checkbox>
      </li>
    </ul>
    <div v-if="selectedGroups.length > 0" class="buttons mt-4 is-centered">
      <b-button type="is-primary" @click="filter">
        Filter by {{ selectedGroups.length.toLocaleString() }}
        group{{ selectedGroups.length === 1 ? '' : 's' }}
      </b-button>
    </div>
  </figure>
</template>

<script>
export default {
  emits: ['filter'],
  props: {
    agg: Array
  },
  data () {
    return {
      selectedGroups: []
    }
  },
  methods: {
    filter () {
      this.$store.commit('filters/setGroups', this.selectedGroups)
      this.$emit('filter')
    }
  }
}
</script>

<style lang="scss" scoped>
figure ul {
  column-count: 2;
}
</style>